module.exports = __webpack_public_path__ + "static/media/mage.3bfa6dfe.png";